export default __webpack_public_path__ + "static/media/create-insurance.2cfe304f.webp";